import { render, staticRenderFns } from "./DistributorApply.vue?vue&type=template&id=7b9e9edf"
import script from "./DistributorApply.vue?vue&type=script&lang=js"
export * from "./DistributorApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports